export default __webpack_public_path__ + "static/media/FECHAS_15.e324bc7a.png";